import { api } from "@/lib/api-client";
import type { CreateUserInput, PaginatedResponse, ProfileInput, StaffUser, UpdateUserInput, UsersFilters } from "./types";

function listPath(filters: UsersFilters) {
  const params = new URLSearchParams({
    page: String(filters.page ?? 1),
    pageSize: String(filters.pageSize ?? 10),
    sortBy: filters.sortBy ?? "name",
    sortDir: filters.sortDir ?? "asc",
  });
  if (filters.search) params.set("search", filters.search);
  if (filters.role && filters.role !== "ALL") params.set("role", filters.role);
  if (filters.active === "ACTIVE") params.set("active", "true");
  if (filters.active === "INACTIVE") params.set("active", "false");
  return `/users?${params.toString()}`;
}

export const usersApi = {
  list: (filters: UsersFilters) => api.get<PaginatedResponse<StaffUser>>(listPath(filters)),
  create: (input: CreateUserInput) => api.post<StaffUser>("/users", input),
  update: (id: string, input: UpdateUserInput) => api.patch<StaffUser>(`/users/${id}`, input),
  delete: (id: string) => api.delete<void>(`/users/${id}`),
  resetPassword: (id: string, password: string) => api.post<void>(`/users/${id}/reset-password`, { password }),
  updateProfile: (input: ProfileInput) => api.patch<StaffUser>("/users/profile", input),
  changePassword: (currentPassword: string, newPassword: string) =>
    api.post<void>("/users/change-password", { currentPassword, newPassword }),
};
